module.exports = __webpack_public_path__ + "assets/images/34a2a1934d06893267b52c499ad69b86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/camerama-logo.jpg
// module id = 821
// module chunks = 0